import React, { Component } from 'react'; //different
import Banner from './banner';
import NavMenu from './navmenu';
class App extends Component {
    componentDidMount() {
    }
    render() {
        return (
            <Banner />

        );
    }
}
export default App;
